<script>
   import Modal from './modal.svelte'
   export let content
</script>

<Modal id={'login'}>
   <div class="popup-careers-content">
      {#if content.text}
         {@html content.text}
      {/if}
      {#if content.btns}
      <div class="btns-wrap d-flex flex-column flex-md-row align-items-center" style="margin-top: 1rem;">
         {#each content.btns as btn} 
            <a href={btn['btn'].url} target={btn['btn'].target ? btn['btn'].target : '_blank'} class="btn" style="white-space:normal;">
               {btn['btn'].title}
               {#if btn['btn'].target == '_blank' }
                  <svg aria-hidden="true" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.54813 3.41483H7.74813V3.21483V2.44446V2.24446H7.54813H1.38518C1.06288 2.24446 0.8 2.50733 0.8 2.82964V13.6148C0.8 13.9371 1.06301 14.2001 1.38532 14.2001L12.1704 14.2C12.4927 14.2 12.7555 13.9371 12.7555 13.6148V7.45186V7.25186H12.5555H11.7852H11.5852V7.45186V13.0296H1.97037V3.41483H7.54813Z" fill="black" stroke="black" stroke-width="0.4" focusable="false"/> <path d="M14.1996 0.999756V0.799756H13.9996H9.9183H9.7183V0.999756V1.80222V2.00222H9.9183H12.1372L6.63573 7.51901L6.49489 7.66024L6.63573 7.80146L7.1959 8.36319L7.33727 8.50496L7.47889 8.36343L12.9993 2.84657V5.07228V5.27228H13.1993H13.9996H14.1996V5.07228V0.999756Z" fill="#000" stroke="#000" stroke-width="0.4"/> </svg>
               {:else}
                  <svg aria-hidden="true" width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false"> <path d="M0.284668 4.27889L0.284668 6.01519L10.3555 6.00651L8.06565 8.6891L9.11053 9.92188L13.1937 5.13836L9.11053 0.354841L8.06565 1.58762L10.3555 4.27021L0.284668 4.27889Z" fill="#000"/> </svg>
               {/if}
            </a>
         {/each}
      </div>
      {/if}
   </div>
</Modal> 